// src/oura/ui/useOuraBrand.ts
//
// Puts Oura's blue on the page while an /oura route is open: the class on
// <html> switches Tailwind's blue scale to #0B49FE (src/index.css), and comes
// off when the person leaves Oura for the rest of the app.

import { useLayoutEffect } from "react";

export function useOuraBrand() {
    // Before paint, so the first frame is already in Oura's blue.
    useLayoutEffect(() => {
        const root = document.documentElement;
        root.classList.add("oura-brand");
        return () => root.classList.remove("oura-brand");
    }, []);
}
